// TODO: Move folder to models.
import moment from 'moment'

export default class Period {

  public start = moment().format('YYYY-MM-DD HH:mm')
  public end = moment().format('YYYY-MM-DD HH:mm')
  public timeIncluded = false
}
